import type { VuiContext } from '../types'

import { createContext } from '../../utils'

const [VuiContextProvider, useVuiContext] = createContext<VuiContext>({
  isOptional: true,
})

export { VuiContextProvider, useVuiContext }
